import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "kno2-bottom-pane",
    template: "<ng-content></ng-content>",
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class BottomPaneComponent {}
